export function getRandomNumber(multiplier: number): number {
  return (Math.floor(Math.random() * 9999) + 1) * multiplier;
}
